function runLensAdvizorGAListeners() {
  // First step to appear. Data layer does not run until the user clicks and makes a selection on first step
  document.addEventListener("LensAdvizor:prescriptionTypes:rendered", function() {
    window.dataLayer = window.dataLayer || [];

    // Reset stored step index if necessary; i.e. if user steps through flow multiple times in same session
    if (sessionStorage.getItem("LAStepIndex")) {
      sessionStorage.setItem("LAStepIndex", 0);
      sessionStorage.removeItem("LALastStepEvent");
    }

    // Close modal listener; should only need to be called once on the first step
    modalCloseListener();

    const allButtons = document.querySelectorAll(".la-label-btn-wrapper .la-label-btn");

    allButtons?.forEach(function(lenses) {
      if (lenses && !lenses.classList.contains('has-listener')) {
        lenses.addEventListener("click", function() {
          const stepTitle = document.querySelector("h3#la_prescriptionSelect_title").innerHTML.trim();
          const eventText = this.querySelector(".la-label-content-box .la-label-title").innerHTML.trim();

          // Data layer update
          lensAdvizorDataLayer(eventText, stepTitle, window.dataLayer);
        });

        lenses.classList.add('has-listener');
      }
    });
  });
  
  // Submission methods, such as use my prescription on file and send later.
  document.addEventListener("LensAdvizor:render:submissionMethods", function() {
    window.dataLayer = window.dataLayer || [];

    // Modal back button listener
    modalBackButtonListener(window.dataLayer);

    const allButtons = document.querySelectorAll(".la-label-btn-wrapper .la-label-btn");

    allButtons?.forEach(function(lenses){
      if (lenses && !lenses.classList.contains('has-listener')) {
        lenses.addEventListener("click", function() {
          const stepTitle = document.querySelector("h3#la_prescriptionSelect_title").innerHTML.trim();
          const eventText = this.querySelector(".la-label-content-box .la-label-title").innerHTML.trim();

          lensAdvizorDataLayer(eventText, stepTitle, window.dataLayer);
        });

        lenses.classList.add('has-listener');
      }
    });
  });

  // Choose Lens, such as Plastic, or UltraX HD
  document.addEventListener("LensAdvizor:lens:rendered", () => {
    window.dataLayer = window.dataLayer || [];

    const allButtons = document.querySelectorAll(".la-label-btn");

    allButtons?.forEach(function(lenses){

      if (lenses && !lenses.classList.contains('has-listener')) {
        lenses.addEventListener("click", function() {
          const stepTitle = document.querySelector("h3#la_prescriptionSelect_title").innerHTML.trim();
          const eventText = this.querySelector(".la-label-content-box .la-label-title").innerHTML.trim();
          
          lensAdvizorDataLayer(eventText, stepTitle, window.dataLayer);
        });

        lenses.classList.add('has-listener');
      }
    });
  });

  // Step where you can choose lens option, like Clear to Brown, or Clear to Grey
  // Select UltraX HD to see
  document.addEventListener("LensAdvizor:lensOptions:rendered", () => {
    const allButtons = document.querySelectorAll(".la-label-btn");

    allButtons?.forEach(function(btn){
      if (btn && !btn.classList.contains('has-listener')) {
        btn.addEventListener("click", function() {
          const stepTitle = document.querySelector("h3#la_prescriptionSelect_title").innerHTML.trim();
          const eventText = this.querySelector(".la-label-content-box .la-label-title").innerHTML.trim();
          
          lensAdvizorDataLayer(eventText, stepTitle, window.dataLayer);
        });

        btn.classList.add('has-listener');
      }
    });

  });

  // Enter prescription manually
  document.addEventListener('LensAdvizor:render:manualEntryForm', function() {
    window.dataLayer = window.dataLayer || [];

    let eventButton = document.querySelector(".la-prescription-form-btn");

    if (eventButton && !eventButton?.classList.contains('has-listener')) {
      eventButton.addEventListener("click", () => {
        const stepTitle = document.querySelector("h3#la_prescriptionSelect_title").innerHTML.trim();
        const eventText = "Save and Continue.";
        const agreeBox = document.querySelector(".la-signed-field");

        if (agreeBox.checked) {
          lensAdvizorDataLayer(eventText, stepTitle, window.dataLayer);
        }
      });

      eventButton.classList.add('has-listener');
    }
  });

  // Upload form for prescription
  document.addEventListener("LensAdvizor:render:uploadForm", function() {
    window.dataLayer = window.dataLayer || [];
    let eventButton = document.querySelector(".la-prescription-form-btn");

    if(eventButton && !eventButton.classList.contains('has-listener')) {
      eventButton.addEventListener("click", () => {
        const stepTitle = document.querySelector("h3#la_prescriptionSelect_title").innerHTML.trim();
        const eventText = "Save and Continue.";
        const uploaded = document.querySelector("#la-prescription-upload-message");

        // If the successful upload element contains the checkmark SVG, we are good to run the data layer event
        if (uploaded.innerHTML.includes("svg")) {
          lensAdvizorDataLayer(eventText, stepTitle, window.dataLayer);
        }
      });

      eventButton.classList.add('has-listener');
    }
  });

  document.addEventListener("LensAdvizor:addOns:rendered", function() {
    window.dataLayer = window.dataLayer || [];

    const allButtons = document.querySelectorAll(".la-label-btn");

    allButtons?.forEach(function(lenses){
      if (lenses && !lenses.classList.contains('has-listener')) {
        lenses.addEventListener("click", function() {
          const stepTitle = document.querySelector("h3#la_prescriptionSelect_title").innerHTML.trim();
          const eventText = this.querySelector(".la-label-content-box .la-label-title").innerHTML.trim();
          
          lensAdvizorDataLayer(eventText, stepTitle, window.dataLayer);
        });

        lenses.classList.add('has-listener');
      }
    });
  });
}

// Runs on step change to push to dataLayer
// Determine if we have moved forward or backward in the LensAdvizor steps by checking stepIndex
function lensAdvizorDataLayer(eventText, stepTitle, dataLayer) {
  const currentStepIndex = window.LensAdvizor.stepIndex;
  const storedStepIndex = Number(sessionStorage.getItem("LAStepIndex"));

  // Return if stepIndex doesn't exist for some reason; the rest of the function cant be run
  if (typeof currentStepIndex == "undefined") {
    return;
  }

  // Some LensAdvizor cards can fire duplicate click events for a single user action.
  // Ignore immediate duplicate payloads so we don't push Forward + Backward for one click.
  const duplicateKey = [eventText, stepTitle, currentStepIndex].join("::");
  const now = Date.now();
  const previousStepEvent = JSON.parse(sessionStorage.getItem("LALastStepEvent") || "null");

  if (
    previousStepEvent?.key === duplicateKey &&
    now - previousStepEvent.timestamp < 700
  ) {
    return;
  }

  sessionStorage.setItem("LALastStepEvent", JSON.stringify({
    key: duplicateKey,
    timestamp: now
  }));

  // Format info about this current step
  const lensType = LensAdvizor?.response?.lens?.name || "Not yet selected.";
  const lensName = LensAdvizor?.response?.lens?.group_title || "Not yet selected.";
  const visionType = LensAdvizor?.response?.selectedPrescriptionType?.title || "Not yet selected.";
  const stepDirection = currentStepIndex < storedStepIndex ? "Backward" : "Forward";

  // Push to data layer
  dataLayer.push({
    "event": "LensAdvizorStep",
    "eventAction": "Click",
    "eventText": eventText,
    "eventSelectedVisionType": visionType,
    "eventLabel": "Step " + currentStepIndex + ": " + stepTitle,
    "eventStepDirection": stepDirection,
    "eventLensType": lensType,
    "eventLensName": lensName
  });

  sessionStorage.setItem("LAStepIndex", currentStepIndex);
}

function modalCloseListener() {
  window.dataLayer = window.dataLayer || [];

  const closeButton = document.querySelector(".la-prescription-modal-close");
  const modalBG = document.querySelector(".la-prescription-modal");

  if (!closeButton || typeof closeButton == "undefined") {
    return;
  };

  // Prevent addition of duplicate event listeners (i.e. if user steps all the way back to first step)
  if (closeButton && !closeButton.classList.contains('has-listener')) {
    closeButton.addEventListener("click", () => {
      const stepTitle = document.querySelector("h3#la_prescriptionSelect_title").innerHTML.trim();
      const currentStepIndex = window.LensAdvizor.stepIndex;

      window.dataLayer.push({
        "event": "LensAdvizorStep",
        "eventAction": "Close Modal",
        "eventLabel": "Step " + currentStepIndex + ": " + stepTitle,
        "eventContext": "Clicked X icon"
      });

      // Reset stored step index since modal has been closed
      sessionStorage.setItem("LAStepIndex", 0);
      sessionStorage.removeItem("LALastStepEvent");
    });

    closeButton.classList.add('has-listener');
  }

  if (modalBG && !modalBG.classList.contains('has-listener')) {
    // Detect user clicking off the modal
    modalBG.addEventListener("click", (event) => {
      // Prevent duplicate events, if the user clicks the X button
      if (event.target.matches("img") || event.target.matches("button")) {
        return;
      };

      // Delay for the classes to all update
      setTimeout(() => {
        // See if the modal actually closed or not
        // A click can still register if the user clicks a part of the modal without closing it.
        if (!document.querySelector("body")?.classList?.contains("la-modal-open")) {
          const stepTitle = document.querySelector("h3#la_prescriptionSelect_title")?.innerHTML.trim();
          const currentStepIndex = window.LensAdvizor.stepIndex;

          window.dataLayer.push({
            "event": "LensAdvizorStep",
            "eventAction": "Close Modal",
            "eventLabel": "Step " + currentStepIndex + ": " + stepTitle,
            "eventContext": "Clicked off modal"
          });

          sessionStorage.setItem("LAStepIndex", 0);
          sessionStorage.removeItem("LALastStepEvent");
        }
      }, 500);
    });
  }

  modalBG.classList.add('has-listener');
}

function modalBackButtonListener(dataLayer) {
  if (document.body.classList.contains("la-back-listener-ready")) {
    return;
  }

  document.body.classList.add("la-back-listener-ready");

  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const backButton = event.target.closest(".la-steeper-back, #la-back-btn");
    if (!backButton) {
      return;
    }

    const storedStepIndex = Number(sessionStorage.getItem("LAStepIndex"));
    if (storedStepIndex <= 0) {
      return;
    }

    let attempts = 0;
    const maxAttempts = 8;

    const resolveBackStep = () => {
      const currentStepIndex = Number(window.LensAdvizor?.stepIndex);
      const hasSteppedBack = Number.isFinite(currentStepIndex) && currentStepIndex < storedStepIndex;

      attempts += 1;
      if (!hasSteppedBack && attempts < maxAttempts) {
        setTimeout(resolveBackStep, 50);
        return;
      }

      const eventStepIndex = hasSteppedBack ? currentStepIndex : Math.max(storedStepIndex - 1, 0);
      const stepTitle = document.querySelector("h3#la_prescriptionSelect_title")?.innerHTML.trim() || "Unknown Step";
      const lensType = LensAdvizor?.response?.lens?.name || "Not yet selected.";
      const lensName = LensAdvizor?.response?.lens?.group_title || "Not yet selected.";
      const visionType = LensAdvizor?.response?.selectedPrescriptionType?.title || "Not yet selected.";

      dataLayer.push({
        "event": "LensAdvizorStep",
        "eventAction": "Click",
        "eventContext": "Clicked back button",
        "eventSelectedVisionType": visionType,
        "eventLabel": "Step " + eventStepIndex + ": " + stepTitle,
        "eventStepDirection": "Backward",
        "eventLensType": lensType,
        "eventLensName": lensName
      });

      sessionStorage.setItem("LAStepIndex", eventStepIndex);

      if (eventStepIndex === 0 || stepTitle == 'Choose Your Prescription Type') {
        sessionStorage.setItem("LAStepIndex", 0);
        sessionStorage.removeItem("LALastStepEvent");
      }
    };

    setTimeout(resolveBackStep, 0);
  });
}
